import {Review} from "../model/types";

export const getReviewStats = (reviews: Review[]): Record<number, number> => {
    return reviews.reduce((acc, review) => {
        acc[review.rating] = (acc[review.rating] || 0) + 1;
        return acc;
    }, {} as Record<number, number>);
};
